/** What the sign-up form collected, kept while the address is being proved. */
export type SignupDetails = {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
};

/** The code email goes out in the language the brand reads the dashboard in. */
export const signupLanguage = (uiLanguage: string | undefined): 'en' | 'fr' =>
  uiLanguage?.toLowerCase().startsWith('fr') ? 'fr' : 'en';
